const routes = [
  {
    path: 'cuentas',
    name: 'purecloud.cuentas',
    meta: { purecloud: true },
    component: () => import('@/views/Cuentas/Cuentas')
  },
  {
    path: 'cuentas/:cuentaId/caso/nuevo',
    name: 'purecloud.caso.nuevo',
    meta: { purecloud: true },
    component: () => import('@/views/Casos/Guardar')
  },
  {
    path: 'cuentas/editar/:cuentaId',
    name: 'purecloud.cuentas.editar',
    meta: { purecloud: true },
    component: () => import('@/views/Cuentas/Guardar')
  },
  {
    path: 'cuentas/nuevo',
    name: 'purecloud.cuentas.nuevo',
    meta: { purecloud: true },
    component: () => import('@/views/Cuentas/Guardar')
  },
  {
    path: 'cuentas/:cuentaId/caso/editar/:casoId',
    name: 'purecloud.caso.editar',
    meta: { purecloud: true },
    component: () => import('@/views/Casos/Guardar')
  },
  {
    path: 'contacto/editar/:contactId',
    name: 'purecloud.contactos.editar',
    meta: { purecloud: true },
    component: () => import('@/views/Contactos/Guardar')
  }, {
    path: 'contacto/nuevo',
    name: 'purecloud.contactos.nuevo',
    meta: { purecloud: true },
    component: () => import('@/views/Contactos/Guardar')
  }, {
    path: 'contacto/:contactId/caso/editar/:casoId',
    name: 'purecloud.casos.editar',
    meta: { purecloud: true },
    component: () => import('@/views/Casos/Guardar')
  },
  {
    path: 'contacto/:contactId/caso/nuevo',
    name: 'purecloud.casos.nuevo',
    meta: { purecloud: true },
    component: () => import('@/views/Casos/Guardar')
  },
  {
    path: 'contacto',
    name: 'purecloud.contactos',
    meta: { purecloud: true },
    component: () => import('@/views/Contactos/Contactos')
  }
]

export default routes
